// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IQHcd","tabsBox":"styles_tabsBox__2zfoD","createButton":"styles_createButton__1H_Q3"};